var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVarifyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "{styles.icon}",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6V2L8 6l4 4V7c2.76 0 5 2.24 5 5 0 1.05-.32 2.02-.87 2.83l1.46 1.46C19.16 15.39 20 13.79 20 12c0-4.42-3.58-8-8-8zm-5.5 6c0-1.05.32-2.02.87-2.83L5.91 7.71C4.84 8.61 4 10.21 4 12c0 4.42 3.58 8 8 8v4l4-4-4-4v3c-2.76 0-5-2.24-5-5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarifyIcon);
export default __webpack_public_path__ + "static/media/varifyIcon.05fb1d2fe9810661c6b6ffdf27b82695.svg";
export { ForwardRef as ReactComponent };